import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { DELETE_TRAINERTAG_MSB } from '@/graphql/Mystage/trainerTag';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';

import logger from '@/modules/Logger';

export const DeleteTrainerTagService = {
  // Method to store trainer tags and update from new GraphQL endpoint
    msb: async (params, callback) => {
    logger.debug(`[Delete TrainerTag] Deleting trainer tags from MSB GraphQL endpoint`, {
      operation: 'tag:delete_trainer_tag'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: DELETE_TRAINERTAG_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        message_id: params.id
      }
    });

    if (data?.deleteTags) {
      callback(data.deleteTags);
      return data.deleteTags;
    } else {
      logger.error(`[Delete TrainerTag] Empty result from delete GraphQL API`, {
        event_type: 4,
      });
    }
  },

  // Method to  store trainer tags and update from legacy REST API endpoint
  legacy: async (params, callback) => {
    logger.debug(`[Delete TrainerTag] Deleting using legacy REST API`, {
      operation: 'tag:delete_trainer_tag'
    });

    try {
      let responseData;
      await bizmatesWordbookApi.delete('trainertag/tags', params, response => {
        responseData = response.data.data;
        callback(responseData);
      });

      return responseData;
    } catch (error) {
      logger.error(`[Delete TrainerTag] Error deleting tags`, {
        error
      });
      throw error;
    }
  }
};
